import { jsx as _jsx } from "react/jsx-runtime";
import { Toolbar } from 'analysis-ui-components';
import { useCallback, useState, useEffect, } from 'react';
export default function ToggleButton(props) {
    const { children, value = null, isActive = false, onChange = () => null, isVisible = true, id, title, } = props;
    const [active, setActive] = useState(props.isActive);
    const toggleButton = useCallback(() => {
        const _isActive = !active;
        setActive(_isActive);
        if (_isActive) {
            onChange(value);
        }
        else {
            onChange(null);
        }
    }, [active, onChange, value]);
    useEffect(() => {
        setActive(isActive);
    }, [isActive]);
    if (!isVisible) {
        return null;
    }
    return (_jsx(Toolbar.Item, { onClick: toggleButton, title: title, id: id, active: active, children: children }));
}
